
// src/connects/diary-comment-form.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import { pushRoute } from '../actions/route'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import componentId from '../helpers/component-id'
import uploadFiles from '../helpers/file-upload'
import combineHOC from '../helpers/combine-hoc'
import each from 'lodash/each'
import filter from 'lodash/filter'
import map from 'lodash/map'

export const mapStateToProps = (state, ownProps)=> {
  return {
    isPosting: state.comments.isPosting,
    isPostFailed: state.comments.isPostFailed,
    uploadedFiles: state.uploadFile[ownProps.componentId],
    uploadedVideos: state.uploadVideo[ownProps.componentId],
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var isUploading
  each(stateProps.uploadedFiles, (value, key)=> {
    value && value.isUploading && (isUploading = true)
  })
  each(stateProps.uploadedVideos, (value, key)=> {
    value && value.isUploading && (isUploading = true)
  })
  return {
    isUploading,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    submitComment: (props)=> {
      props.ui.handlers && props.ui.handlers.getValue((value)=> {
        const files = filter(map(props.uploadedFiles, (file)=> file && file.item && file.item.file_id), (file)=> file)
        const videos = filter(map(props.uploadedVideos, (file)=> file && file.item && file.item.video_id), (file)=> file)
        const mentions = map(props.ui.mentions, (mention)=> mention.user_id)
        if (!value || value.length == 0)
          return
				if (props.editComment && props.editComment.comment_id)
					dispatch(actions.putComment(
						props.editComment.comment_id,
	          value, files, videos, mentions, props.ui.reply_requested
					))
				else
	        dispatch(actions.postComment(
	          props.parent.comment_id ? 'comment_id' : 'diary_id',
	          props.parent.comment_id || props.parent.diary_id,
	          value, files, videos, mentions, props.ui.reply_requested
	        ))
      })
    },

    uploadFiles: (files)=> uploadFiles(files, dispatch, ownProps.group.group_id, 'group', ownProps.componentId),

		willMount: (props)=> {
			if (props.editComment) {
				each(filter(props.editComment.files, (file)=> file.file_id),  (file, i)=> dispatch(actions.uploadFileCompleted(file, ownProps.componentId, i, false)))
				each(filter(props.editComment.files, (file)=> file.video_id), (file, i)=> dispatch(actions.uploadVideoCompleted(file, ownProps.componentId, i, false)))
			}
		},

    willUpdate: (props, nextProps)=> {
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed) {
        ownProps.onClose()
      }
			if (!props.ui.handlers && nextProps.ui.handlers && nextProps.editComment) {
				setTimeout(()=> nextProps.ui.handlers.insertValue(nextProps.editComment.comment), 300)
			}
    },

    willUnmount: ()=> {
      dispatch(actions.clearUploadFilesAndVideos(ownProps.componentId))
    },
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
		state: {
			handlers: undefined,
			mentions: (props)=> props.editComment && props.editComment.mentions,
			reply_requested: (props)=> props.editComment && props.editComment.reply_requested,
		}
	}),
  translate(),
  context({ showUserSelectionDialog: PropTypes.func }),
  lifecycle,
)



// WEBPACK FOOTER //
// ./src/connects/diary-comment-form.js